import { createFileRoute } from '@tanstack/react-router';

import { assertPermissionOrRedirect, Permission } from '@auth/data-access';
import { GpSurfacesMapPage } from '@contracts';

export const Route = createFileRoute('/_app/os/surfaces-map')({
  beforeLoad(ctx) {
    assertPermissionOrRedirect(ctx.context.auth, Permission.SurfacesMap);
  },
  component: GpSurfacesMapPage,
});
